/**
 * Requests an optimized/resized rendition of a Cloudinary-hosted image by
 * inserting a transformation segment into the URL, e.g.
 *   .../upload/v123/foo.jpg -> .../upload/f_auto,q_auto,w_1920/v123/foo.jpg
 *
 * Non-Cloudinary URLs (or anything that doesn't match the expected shape)
 * are returned unchanged, so this is always safe to call.
 */
export const cloudinaryOptimized = (
  url: string | null | undefined,
  { width }: { width?: number } = {},
): string => {
  if (!url || !url.includes("res.cloudinary.com")) return url || "";

  const marker = "/upload/";
  const idx = url.indexOf(marker);
  if (idx === -1) return url;

  const transforms = ["f_auto", "q_auto"];
  if (width) transforms.push(`w_${width}`);

  const head = url.slice(0, idx + marker.length);
  const tail = url.slice(idx + marker.length);
  return `${head}${transforms.join(",")}/${tail}`;
};
